import { VenueType } from '../../../App.types'

export type TrainerTranslationKey = 'activity-details-trainer-heading' | 'activity-details-teacher-heading'

const teacherVenues = new Set<VenueType>([VenueType.STUDIOYOGA, VenueType.STUDIOONLINE])

export function getTrainerTranslationKey(venueType?: VenueType | null): TrainerTranslationKey {
  return venueType && teacherVenues.has(venueType)
    ? 'activity-details-teacher-heading'
    : 'activity-details-trainer-heading'
}
